import { Dispatch } from 'react';
import { get, IResponseError, post, put, remove } from 'communication/httpClient';
import { IGenericObject } from 'types';
import { cleanObject } from 'utils/object';

import {
  CLEAN_TAX_ZONES,
  DELETE_INITIATED,
  SET_TAX_ZONES_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TAX_ZONE_CREATED,
  TAX_ZONE_DELETED,
  TAX_ZONE_UPDATED,
  CREATE_INITIATED,
  UPDATE_INITIATED,
} from './actionTypes';
import { ITaxZonesAction, ITaxZoneActions, ITaxZone } from './types';

export const getActions = (dispatch: Dispatch<ITaxZonesAction>): ITaxZoneActions => ({
  loadTaxZones: async (params?: IGenericObject) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get('/api/tax-zones', {
      params: params ? cleanObject(params) : {},
    });

    if (data) {
      dispatch({
        type: SET_TAX_ZONES_LIST,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  saveTaxZone: async (
    taxZone: ITaxZone,
    isNew: boolean,
    onDone?: (error?: IResponseError) => void
  ) => {
    dispatch({
      type: isNew ? CREATE_INITIATED : UPDATE_INITIATED,
    });
    const handler = isNew ? post : put;
    const url = `/api/tax-zones/${isNew ? '' : taxZone.zoneId}`;
    const { error } = await handler(url, taxZone);

    if (!error) {
      dispatch({
        type: isNew ? TAX_ZONE_CREATED : TAX_ZONE_UPDATED,
        payload: taxZone,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }

    if (onDone) onDone(error);
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  removeTaxZone: async (zoneId: string, onDone?: (error?: IResponseError) => void) => {
    dispatch({
      type: DELETE_INITIATED,
    });
    const url = `/api/tax-zones/${zoneId}`;
    const { error } = await remove(url);

    if (!error) {
      dispatch({
        type: TAX_ZONE_DELETED,
        payload: zoneId,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    if (onDone) onDone(error);
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  cleanTaxZones: () => {
    dispatch({
      type: CLEAN_TAX_ZONES,
    });
  },
});
